import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { RegistrationContainer } from '../../components/RegistrationContainer'
import { PaginationProvider } from '../../contexts/PaginationContext'
import { useBreadcrumb } from '../../hooks/useBreadcrumb'

import { GroupsTable, GroupForm } from './components'

export const Groups: React.FC = () => {
  const breadcrumb = useBreadcrumb({
    grupos: 'Grupos',
    inclusao: 'Inclusão',
    edicao: 'Edição'
  })

  return (
    <RegistrationContainer breadcrumbItems={breadcrumb}>
      <PaginationProvider>
        <Routes>
          <Route path="/" element={<GroupsTable />} />
          <Route path="/inclusao" element={<GroupForm />} />
          <Route path="/edicao" element={<GroupForm />} />
        </Routes>
      </PaginationProvider>
    </RegistrationContainer>
  )
}
